import { render, staticRenderFns } from "./CorporateBooking.vue?vue&type=template&id=c371a908"
import script from "./CorporateBooking.vue?vue&type=script&lang=js"
export * from "./CorporateBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports